import { useWatch } from "react-hook-form";
import { DateInput, minLength, PasswordInput, required, SelectArrayInput, SelectInput, TextInput } from "react-admin";
import { DialogContent, DialogActions } from "@mui/material";
import { GENDER_CHOICES } from "../../model/Gender";
import { DRIVING_LICENSE_CLASSES_CHOICES } from "../../model/DrivingLicenseClass";
import { DateTime } from "luxon";
import { date, dateNotInThePast, dateMaxYear, dateMinYear, email } from "../../utils/validators";
import { SaveButton2 } from "../../buttons/SaveButton2";
import { Form2 } from "../../misc/Form2";

const ROLE_CHOICES: Array<{ id: string; name: string }> = [
  { id: "instructor", name: "Fahrlehrer" },
  { id: "drivingSchoolCustomerService", name: "Kundenservice" },
  { id: "drivingSchoolAccountant", name: "Buchhaltung" },
];

export function CreateEmployeeForm() {
  return (
    <Form2>
      <DialogContent>
        <_CommonInputs />
        <_InstructorInputs />
      </DialogContent>
      <DialogActions>
        <SaveButton2 />
      </DialogActions>
    </Form2>
  );
}

function _CommonInputs() {
  return (
    <>
      <TextInput
        label="E-Mail"
        source="email"
        validate={[required("Bitte gib eine E-Mail-Adresse ein."), email()]}
        fullWidth
      />
      <PasswordInput
        label="Passwort"
        source="password"
        autoComplete="off"
        validate={[required("Bitte gib ein Passwort ein."), minLength(8)]}
        fullWidth
      />
      <TextInput label="Vorname" source="firstName" validate={required("Bitte gib den Vornamen ein.")} fullWidth />
      <TextInput label="Nachname" source="lastName" validate={required("Bitte gib den Nachnamen ein")} fullWidth />
      <TextInput label="Telefonnummer" source="phoneNumber" fullWidth />
      <SelectInput
        label="Rolle"
        source="role"
        validate={required("Bitte wähle die Rolle des neuen Mitarbeiters aus.")}
        choices={ROLE_CHOICES}
        fullWidth
      />
    </>
  );
}

function _InstructorInputs() {
  const role = useWatch({ name: "role" });

  if (role !== "instructor") {
    return null;
  }

  return (
    <>
      <SelectInput
        label="Geschlecht"
        source="gender"
        validate={required("Bitte wähle das Geschlecht des neuen Fahrlehrers aus.")}
        choices={GENDER_CHOICES}
        fullWidth
        sx={{ margin: 0 }}
      />
      <SelectArrayInput
        label="Führerscheinklassen"
        source="drivingLicenseClasses"
        validate={required("Bitte wähle die Führerscheinklassen aus, die von dem Fahrlehrer unterrichtet werden.")}
        choices={DRIVING_LICENSE_CLASSES_CHOICES}
        fullWidth
      />
      <DateInput
        label="Startdatum"
        source="startDate"
        validate={[
          required("Bitte gib das Startdatum der Beschäftigung des Fahrlehrers ein."),
          date(),
          dateMinYear(1950),
          dateMaxYear(2099),
        ]}
        fullWidth
        defaultValue={DateTime.now()}
      />
      <DateInput
        label="Enddatum"
        source="endDate"
        validate={[
          required("Bitte gib das Enddatum der Beschäftigung des Fahrlehrers ein."),
          date(),
          dateNotInThePast(),
          dateMaxYear(2099),
        ]}
        fullWidth
        defaultValue={DateTime.now().plus({ years: 45 })}
      />
    </>
  );
}
